import React, { useState, useEffect } from 'react'

import { Button, Card, Form, Icon, notification, Typography } from 'antd'
import { Formik } from 'formik'
import moment from 'moment'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import FormHeader from '../../components/FormHeader/FormHeader'
import { validRule, RULES } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
import ConfigurationRow from './ConfigurationRow'
import { configSchema } from './Validation'
import CustomSelect from '../../components/CustomSelect/customSelect'

const SelectReferencePeriod = ({ onChange, configurations }) => {
  const [formValues, setFormValues] = useState({})
  const [referencePeriodValues, setReferencePeriodValues] = useState([])

  useEffect(() => {
    try {
      loadReferencePeriodValues()
    } catch (error) {
      console.tron.log(error)
    }
  }, [])

  useEffect(() => {
    if (formValues.referencePeriod) {
      onChange(formValues.referencePeriod)
    }
  }, [formValues.referencePeriod])

  useEffect(() => {
    if (configurations.length && referencePeriodValues.length && !formValues.referencePeriod) {
      setFormValues({ referencePeriod: referencePeriodValues.at(-1).value })
    }
  }, [referencePeriodValues, configurations])

  async function handleChange(field, value) {
    setFormValues({ ...formValues, [field]: value })
  }

  async function loadReferencePeriodValues() {
    const referencePeriods = await request(api.listSafraDropdown({ active: true }))
    setReferencePeriodValues(referencePeriods.slice(1))
  }

  return (
    <CustomSelect
      showSearch
      field="referencePeriod"
      setFieldValue={handleChange}
      rowSpan={4}
      value={formValues}
      values={referencePeriodValues}
      required
    />
  )
}

const CreateConfiguration = ({ match, history }) => {
  // Params url
  const { id } = match.params

  // UseStates
  const [formLayout] = useState('vertical')
  const [formValues, setFormValues] = useState([])
  const [configurations, setConfigurations] = useState([])

  // Mount/Umount component
  useEffect(() => {
    const hasAccess = validRule(RULES.CONFIG_DOCUMENT) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    onCreateContainer()
  }, [])

  async function updateFormValuesByReferencePeriod(referencePeriodId) {
    if (!referencePeriodId) {
      return false
    }

    const configurations = await loadWalletConfiguration(+referencePeriodId)
    const referencePeriodConfiguration = configurations.filter(
      (configuration) => +configuration.referencePeriodId == +referencePeriodId
    )
    setFormValues(referencePeriodConfiguration)
  }

  async function storeEibConfigCalendar(data) {
    try {
      const dataArr = Array.isArray(data) ? data : [data]

      const configCalendarios = dataArr.map((data) => {
        return {
          clientEditionPeriodStartDate: data.clientEditionPeriodStartDate._isValid
            ? moment(data.clientEditionPeriodStartDate).format('YYYY-MM-DD')
            : null,

          clientEditionPeriodEndDate: data.clientEditionPeriodEndDate._isValid
            ? moment(data.clientEditionPeriodEndDate).format('YYYY-MM-DD')
            : null,

          actionPlanningPeriodStartDate: data.actionPlanningPeriodStartDate._isValid
            ? moment(data.actionPlanningPeriodStartDate).format('YYYY-MM-DD')
            : null,

          actionPlanningPeriodEndDate: data.actionPlanningPeriodEndDate._isValid
            ? moment(data.actionPlanningPeriodEndDate).format('YYYY-MM-DD')
            : null,

          actionExecutionPeriodStartDate: data.actionExecutionPeriodStartDate._isValid
            ? moment(data.actionExecutionPeriodStartDate).format('YYYY-MM-DD')
            : null,

          actionExecutionPeriodEndDate: data.actionExecutionPeriodEndDate._isValid
            ? moment(data.actionExecutionPeriodEndDate).format('YYYY-MM-DD')
            : null,

          clientQuantity: data.clientQuantity,
          idOrganization: data.organizationId,
          idSafra: +data.referencePeriodId
        }
      })
      await request(api.storeEibConfigCalendarios(configCalendarios))
      await updateConfiguration(data)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function loadWalletConfiguration(referencePeriodId) {
    const eibConfigCalendarios = await request(api.listEibConfigCalendarios(referencePeriodId))

    const periods = eibConfigCalendarios.map((period) => ({
      ...period,
      organizationId: +period.organizationId,
      referencePeriodId: +period.referencePeriodId,
      clientEditionPeriodStartDate: moment(String(period.clientEditionPeriodStartDate).slice(0, 10)),
      clientEditionPeriodEndDate: moment(String(period.clientEditionPeriodEndDate).slice(0, 10)),
      actionPlanningPeriodStartDate: moment(String(period.actionPlanningPeriodStartDate).slice(0, 10)),
      actionPlanningPeriodEndDate: moment(String(period.actionPlanningPeriodEndDate).slice(0, 10)),
      actionExecutionPeriodStartDate: moment(String(period.actionExecutionPeriodStartDate).slice(0, 10)),
      actionExecutionPeriodEndDate: moment(String(period.actionExecutionPeriodEndDate).slice(0, 10))
    }))
    setConfigurations(periods)

    return periods
  }

  async function onCreateContainer() {
    try {
      loadWalletConfiguration()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function updateConfiguration(data) {
    try {
      if (!data.length) {
        return false
      }

      const configuration = {
        periods: data.concat(
          configurations.filter((configuration) => +configuration.referencePeriodId !== +data[0].referencePeriodId)
        )
      }

      const response = await request(api.findParametersByKey('wallet-configuration'))

      if (response.id) {
        await request(api.updateParameters(response.id, { parameterValue: configuration }))
      }

      notification.success({
        description: getMessage('successConfiguration'),
        message: getMessage('successConfigurationSuccess')
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  function getTitle() {
    return getMessage('updateConfiguration')
  }

  // Form/formik config
  const form = {
    yupValidationUpdate: configSchema,
    onSubmit: async (values) => {
      await storeEibConfigCalendar(values)
    }
  }
  // Header
  function renderHeader(submitForm) {
    const hasAccess = validRule(RULES.CONFIG_DOCUMENT)

    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <div className="default-header-buttons">
            <Button className="button-return" onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button type="primary" className="button-action" onClick={() => submitForm()}>
                {id ? getMessage('update') : getMessage('register')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }
  // Main component
  return (
    <Formik
      enableReinitialize
      validationSchema={form.yupValidationUpdate}
      initialValues={formValues}
      onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
        form.onSubmit(values, setSubmitting, setFieldError, resetForm)
      }
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ values, errors, handleSubmit, setFieldValue, submitForm }) => {
        const setFieldValueWithState = (index, field, value) => {
          setFormValues(
            formValues.map((val, key) => {
              if (key === index) return { ...val, [field]: value }
              return val
            })
          )

          return setFieldValue(`${index}.${field}`, value)
        }

        return (
          <Form className="login-form" layout={formLayout} onSubmit={handleSubmit}>
            {renderHeader(submitForm)}

            <Card className="ant-card gx-card ant-card-bordered">
              <Typography.Title className="default-header-title" level={3}>
                {getTitle()}
              </Typography.Title>

              <SelectReferencePeriod onChange={updateFormValuesByReferencePeriod} configurations={configurations} />
              <FormHeader title={getMessage('clientEditionPeriod')} orientation="left" type="horizontal" />

              {Object.keys(values).map((key) => (
                <ConfigurationRow
                  values={values[key]}
                  errors={errors[key]}
                  handleBlur={form.handleBlur}
                  key={key}
                  setFieldValueWithState={(field, value) => setFieldValueWithState(key, field, value)}
                  period={'walletEdition'}
                />
              ))}

              <FormHeader title={getMessage('actionPlanningPeriod')} orientation="left" type="horizontal" />
              {Object.keys(values).map((key) => (
                <ConfigurationRow
                  values={values[key]}
                  errors={errors[key]}
                  handleBlur={form.handleBlur}
                  key={key}
                  setFieldValueWithState={(field, value) => setFieldValueWithState(key, field, value)}
                  period={'actionPlanning'}
                />
              ))}

              <FormHeader title={getMessage('actionExecutionPeriod')} orientation="left" type="horizontal" />
              {Object.keys(values).map((key) => (
                <ConfigurationRow
                  values={values[key]}
                  errors={errors[key]}
                  handleBlur={form.handleBlur}
                  key={key}
                  setFieldValueWithState={(field, value) => setFieldValueWithState(key, field, value)}
                  period={'actionExecution'}
                />
              ))}
            </Card>
          </Form>
        )
      }}
    </Formik>
  )
}

export default CreateConfiguration
